import type { InjectionKey } from 'vue';

/** Set by `NxList` so its `NxListRow`s render as `li` without a `tag` prop. */
export const listRowTagKey = Symbol('nx-list-row-tag') as InjectionKey<string>;
